module.exports = __webpack_public_path__ + "img/ats.68b20d13.svg";